import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4.5 11.999h14.999m-7.5-6.75h.008v.007h-.008zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0M12 18.75h.008v.008H12zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0"
    }, null, -1)
  ])))
}
export default { render: render }